import { Control } from "react-hook-form";

import { FormConfirmDialog } from "@/components/FormConfirmDialog";

import { ScheduleEditor } from "./ScheduleEditor";

import type { ScheduleEditorState } from "./ScheduleEditor";

export function ScheduleEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<ScheduleEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <ScheduleEditor control={control} />
    </FormConfirmDialog>
  );
}
